const getIsFilterActive = state => state.isFilterActive

export default {
    getIsFilterActive
}
